// This storage is used to save signer object
import { StateCreator } from 'zustand';
import { SignInSource } from '../../constants';
import { DocumentSigner } from '../../data/rsTypes';
import { storeResetFns } from '.';

type State = {
	signer: DocumentSigner;
	searchParams: URLSearchParams;
	isSignFromDashboardFlow: boolean;
	signInSource: string;
};

type Actions = {
	setSigner: (signer: DocumentSigner) => void;
	setSearchParams: (searchParams: URLSearchParams) => void;
	setIsSignFromDashboardFlow: (isSignFromDashboardFlow: boolean) => void;
	setSignInSource: (signInSource: string) => void;
};

export type SignerStore = State & Actions;

const initialState: State = {
	signer: undefined,
	searchParams: new URLSearchParams(),
	isSignFromDashboardFlow: false,
	signInSource: SignInSource.WebApp,
};

export const createSignerSlice: StateCreator<SignerStore> = set => {
	storeResetFns.add(() => {
		set(initialState);
	});
	return {
		...initialState,
		setSigner(signer) {
			set(() => ({ signer }));
		},
		setSearchParams(searchParams) {
			set(() => ({ searchParams }));
		},
		setIsSignFromDashboardFlow(isSignFromDashboardFlow) {
			set(() => ({ isSignFromDashboardFlow }));
		},
		setSignInSource(signInSource) {
			set(() => ({ signInSource }));
		},
	};
};
